import { inject, Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguageService } from '../../../../core/services/language.service';
import { DialogService } from '../../../../osp-ui/services/dialog.service';
import { ViewStock } from '../../../disposition/stocks/contract/view-stock.contract';
import { StockAddEditDialogComponent } from '../components/stock-add-edit-dialog.component';

@Injectable({ providedIn: 'root' })
export class StockAddEditDialogService {
  private readonly dialogService = inject(DialogService);
  private readonly languageService = inject(LanguageService);
  private readonly DIALOG_WIDTH = '1200px';
  private readonly DIALOG_HEIGHT = '830px';

  open(): DynamicDialogRef<StockAddEditDialogComponent> {
    return this.dialogService.open(StockAddEditDialogComponent, {
      header: this.languageService.getInstant('modules.locations.stock.create.header'),
      width: this.DIALOG_WIDTH,
      height: this.DIALOG_HEIGHT,
    });
  }

  openEdit(stock: ViewStock): DynamicDialogRef<StockAddEditDialogComponent> {
    return this.dialogService.open(StockAddEditDialogComponent, {
      header: this.languageService.getInstant('modules.locations.stock.edit.header'),
      width: this.DIALOG_WIDTH,
      height: this.DIALOG_HEIGHT,
      data: {
        stock,
      },
    });
  }
}
